import * as xss from "xss";

const DEFAULT_ALLOWLIST: AllowlistAttrs = {
  a: [""],
  b: [""],
  br: [""],
  ecmstoken: [""],
  h3: [""],
  i: [""],
  li: [""],
  ol: [""],
  s: [""],
  small: [""],
  span: [""],
  strong: [""],
  sup: [""],
  ul: [""],
};

const DEFAULT_ALLOWLISTED_ATTRS: AllowlistAttrs = {
  a: ["target", "href", "download", "class", "id"],
  b: ["class", "id"],
  h3: ["class", "id"],
  ol: ["style"],
  small: ["class", "id"],
  span: ["class", "id", "aria-label", "aria-labelledby", "style"],
  strong: ["class", "id"],
  sup: ["class"],
  ul: ["style"],
};

const makeXssOptions = () => ({
  allowList: DEFAULT_ALLOWLIST,
  stripIgnoreTag: true,
  stripIgnoreTagBody: ["script", "style"],
  onIgnoreTagAttr: (tag: string, name: string, value: string) =>
    DEFAULT_ALLOWLISTED_ATTRS[tag] &&
    DEFAULT_ALLOWLISTED_ATTRS[tag].includes(name)
      ? `${name}="${xss.escapeAttrValue(value)}"`
      : ""
});

const filterXSS = (dangerousHTML: string) =>
  xss.filterXSS(dangerousHTML, makeXssOptions());

export default filterXSS;

interface AllowlistAttrs {
  [index: string]: string[];
}
